import SEO, { getLocalBusinessSchema, getWebSiteSchema } from "@/components/SEO";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustKPIs from "@/components/TrustKPIs";
import DashboardPreview from "@/components/DashboardPreview";
import Services from "@/components/Services";
import SupportServices from "@/components/SupportServices";
import CTABand from "@/components/CTABand";
import Testimonials from "@/components/Testimonials";
import ServiceAreas from "@/components/ServiceAreas";
import LocalKnowledge from "@/components/LocalKnowledge";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Home = () => {
  // Combine LocalBusiness + WebSite schemas
  const schemas = [getLocalBusinessSchema(), getWebSiteSchema()];

  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Rently Properties - Kansas City Property Management | Johnson County KS"
        description="Professional property management in Johnson County, Kansas. Serving Overland Park, Leawood, Lenexa & Olathe. Expert tenant screening, rent collection, 24/7 maintenance. Call 913-795-1155."
        canonical="/"
        keywords="property management Kansas City, Overland Park property management, Leawood rental management, Johnson County property manager, JOCO rentals, Lenexa property management, Olathe rental homes"
        schema={schemas}
      />
      <Header />
      <main>
        <Hero />
        <TrustKPIs />
        <DashboardPreview />
        <Services />
        <SupportServices />
        <CTABand />
        <Testimonials />
        <ServiceAreas />
        <LocalKnowledge />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
